module.exports = __webpack_public_path__ + "static/img/par2.b566b17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_game/par2.png
// module id = 9u3d
// module chunks = 0